import {
  PostCode
} from './enum'

export const transformPostCodeSaveJson = (objectData: any) => {
  let header: any = []
  Object.entries(PostCode)
    .filter(([key]) => isNaN(Number(key)))
    .forEach(([key]) => {
      header = [...header, key]
    })

  let transformed = objectData.map((data: any) => {
    const postCodeValue = data[PostCode.postCode]
    const postCodeStr = postCodeValue?.toString().toLowerCase() || ""

    if (postCodeStr && postCodeStr !== "postcode") {
      const result: any = {}
      header.forEach((head: string, index: number) => {
        result[head] = data[index]
      })
      return result
    }
  })
  return transformed.filter((item: any) => item)
}